import * as T from 'three';
import { C, mesh, ball, box, cyl, ring, link, tube, star, eyes, fur, scarf, boots, limbs, coat, belt, humanHead, gun, antler, candy } from './model-kit.js';

export const humans = {
  'santa'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
coat(r,C.red);limbs(r,C.red,'#a12d46',C.dark);humanHead(r,{beard:true,old:true});belt(body);
      cyl(body,C.white,0,.83,0,.65,.65,.14);box(body,C.white,0,1.72,.45,.15,.83,.10);
      for(const s of [-1,1])ball(body,C.white,s*.31,2,.22,.29,.12,.25);
      cyl(head,C.red,0,.54,0,.04,.46,.75);fur(head,0,.25,0,.42,12);ball(head,C.white,0,.94,0,.14);
      ball(body,'#814253',-.37,1.5,-.51,.5,.65,.31);link(body,C.gold,[-.48,2,.2],[.3,1.03,.48],.065);
      gun(ra,'#4b8b8b');star(body,C.gold,-.45,1.73,.41,.11);
  },
  'mrs-claus'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
coat(r,'#be3e70');limbs(r,'#be3e70',C.white,C.skin);humanHead(r,{old:true});
      cyl(body,'#cc4c78',0,.85,0,.50,.83,.9);box(body,C.white,0,1.05,.53,.75,.88,.10);box(body,C.white,0,1.7,.48,.37,.48,.09);
      tube(body,C.white,[[-.3,1.42,.48],[0,1.3,.61],[.3,1.42,.48]],.065);scarf(body,'#fddeb2',2.04);
      ball(head,C.white,0,.25,-.10,.49,.43,.40);ball(head,C.white,0,.61,-.19,.26,.24,.26);
      // Face cap overlaps only the back of the hair.
      ball(head,C.skin,0,.02,.13,.39,.41,.34);eyes(head,.10,.43,.18);for(const s of [-1,1])ring(head,C.gold,s*.18,.10,.54,.145,.022,.8);
      const pin=cyl(ra,'#dfac6c',0,-.62,.27,.12,.12,.85);pin.rotation.z=.65;link(ra,'#82593d',[-.35,-.98,.27],[.35,-.27,.27],.046);
      for(const s of [-1,1])ball(head,'#ef7996',s*.26,-.07,.42,.09,.06,.045);
  },
  'evil-elf'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
coat(r,'#257657');limbs(r,'#298768','#24563d','#b4d69e');humanHead(r,{angry:true});belt(body,1.25);
      for(const s of [-1,1]){const ear=cyl(head,'#e5c5a0',s*.54,.10,0,0,.19,.65,4);ear.rotation.z=-s*Math.PI/3;}
      cyl(head,'#1e7453',-.03,.56,-.05,.01,.43,.80,8).rotation.z=.2;ball(head,C.gold,-.14,.99,-.05,.09,.11,.09,.6);
      box(body,'#c5ac70',0,1.85,.47,.12,.56,.07);for(const a of [la,ra]){const blade=cyl(a,'#c5e8ec',0,-.80,.23,0,.095,.65,4,.7);blade.rotation.x=-.5;box(a,C.gold,0,-.55,.11,.32,.07,.16,.5);}
      for(const l of [ll,rl]){const toe=cyl(l,'#306d4e',0,-.46,.38,0,.17,.5,6);toe.rotation.x=Math.PI/2;}
  },
  'cowboy'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
head.position.y=2.72;la.position.set(-.43,2.37,0);ra.position.set(.43,2.37,0);
      ball(body,'#253548',0,1.22,0,.72,.53,.75);for(const s of [-1,1])ball(body,'#f2e9d8',s*.54,1.25,.06,.25,.34,.48);
      tube(body,'#d8a390',[[.28,1.25,.52],[.34,1.54,.72],[.29,1.93,.78],[.34,2.08,.86]],.10);
      ball(body,'#eee0c7',.35,2.06,.88,.23,.25,.22);ball(body,'#d99763',.35,2,1.09,.13,.075,.22);
      for(const s of [-1,1])ball(body,C.dark,.35+s*.17,2.14,.98,.055);
      for(const l of [ll,rl]){link(l,'#d6a18d',[0,.27,0],[0,-.4,0],.075);for(const s of [-1,1])link(l,'#b88472',[0,-.43,0],[s*.11,-.52,.35],.055);}
      box(body,'#b87847',0,1.83,0,.63,.82,.38);box(body,'#fff1d5',0,1.93,.23,.23,.60,.08);for(const s of [-1,1]){box(body,'#6b564a',s*.51,1.33,.20,.24,.51,.34).rotation.z=-s*.15;box(body,'#a4744b',s*.56,1.08,.28,.28,.26,.40);}
      for(const a of [la,ra]){cyl(a,'#edddbd',0,-.19,0,.13,.13,.43);ball(a,C.skin,0,-.48,0,.16);}
      humanHead(r,{beard:false,angry:true});ball(head,'#77503b',0,-.24,.29,.28,.16,.11);
      cyl(head,'#986c46',0,.38,0,.56,.59,.09,24);cyl(head,'#b08551',0,.59,0,.31,.37,.4,12);cyl(head,'#543e31',0,.41,0,.36,.36,.11);
      tube(body,C.red,[[-.28,2.38,.20],[0,2.31,.31],[.29,2.39,.20]],.08);box(body,C.red,.06,2.19,.3,.17,.28,.08).rotation.z=.2;
      gun(ra,'#a67945',.4);ring(la,'#e5bd80',-.03,-.52,.18,.30,.027);
  },
  'blitzen'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
coat(r,'#a57c4f');limbs(r,'#ab8557','#8b6748','#51433a');
      ball(body,'#ebc994',0,1.55,.37,.44,.63,.18);ball(head,'#b39366',0,.03,0,.45,.58,.39);eyes(head,.12,.37,.18,C.dark,true);
      ball(head,'#ead19e',0,-.20,.40,.33,.25,.24);ball(head,'#513f36',0,-.13,.60,.16,.105,.08);
      for(const s of [-1,1]){const ear=ball(head,'#ab8657',s*.48,.27,-.04,.31,.12,.13);ear.rotation.z=s*.25;antler(head,s*.23,.43,-.08,s);}
      link(body,'#715441',[-.5,1.92,.41],[.5,1.08,.48],.09);for(let i=0;i<4;i++)ball(body,C.gold,-.35+i*.24,1.78-i*.2,.49,.09,.10,.075,.7);
      scarf(body,'#3b727b',2.04);
  },
  'nutcracker'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
limbs(r,'#c54455','#273b69',C.white);box(body,'#c54455',0,1.52,0,1.10,1.21,.60);humanHead(r,{angry:true});
      box(head,'#e7c199',0,-.20,.35,.53,.34,.24);box(head,C.white,0,-.18,.50,.4,.12,.035);for(let i=0;i<4;i++)box(head,'#845442',-.15+i*.10,-.18,.53,.015,.1,.01);
      for(const s of [-1,1]){const mustache=ball(head,C.dark,s*.16,-.05,.49,.24,.065,.055);mustache.rotation.z=-s*.18;for(let i=0;i<3;i++)ball(head,C.white,s*.45,.2-i*.2,0,.16,.16,.19);}
      cyl(head,C.dark,0,.66,0,.41,.43,.85,16);cyl(head,C.gold,0,.27,0,.44,.44,.1,16,.6);star(head,C.gold,0,.67,.415,.20);
      for(const s of [-1,1]){box(body,C.gold,s*.61,2.05,0,.32,.15,.54,.55);for(let i=0;i<4;i++)cyl(body,C.gold,s*.72,1.96,.18-i*.12,.025,.025,.2,6,.6);}
      for(let i=0;i<3;i++){box(body,C.gold,0,1.79-i*.25,.35,.62,.04,.06,.5);for(const s of [-1,1])ball(body,C.gold,s*.30,1.80-i*.25,.39,.055,.055,.035,.6);}
      belt(body,1.06);gun(ra,'#89533c',1.1);
  },
};
